var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.123 21.1001L29.9757 10.4534L27.0189 9.66017L24.6225 18.5996L27.123 21.1001ZM37.067 31.0441L39.2322 33.2093L47.4688 24.9727L36.75 14.2539L34.5848 16.4191L43.1384 24.9727L37.067 31.0441ZM45.9375 44.245L5.22769 3.53517L3.0625 5.70036L11.933 14.5709L1.53125 24.9727L12.25 35.6914L14.4152 33.5262L5.86163 24.9727L14.0982 16.7361L22.7911 25.429L19.0227 39.492L21.9811 40.2852L25.2917 27.9295L43.7723 46.4102L45.9375 44.245Z",
    fill: "url(#paint0_linear_78_395)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_395",
    x1: 24.5,
    y1: 3.53517,
    x2: 24.5,
    y2: 46.4102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseLogo1);
export default __webpack_public_path__ + "static/media/case-logo-1.886022e58b0bd6aa4cc6bb77c40ceb83.svg";
export { ForwardRef as ReactComponent };